import { Conjoint } from "./model.conjoint";
import { Employer } from "./model.employer";
import { Maladie } from "./maladie";
import { MotifConsultation } from "./motif-consultation";
import { Examen } from "./examen";
import { Ordonnance } from "./ordonnance";
import { RendezVous } from "./rendezvous";
import { Repos } from "./repos";
import { Soins } from "./soins";
import { Agenda } from "./model.agenda";
import { Vaccin } from './vaccin';
import { Actes } from './actes';
import { Document } from './document';
import { Ophtalmo } from './ophtalmo';
export class Consultation {
	consultation_id: any;
	consultation_etat: any;
	consultation_signe: any;
	consultation_repos: any;
	consultation_examen: any;
	examen_id: number;
	repos_id: number;
	ordonnance_id: number;
	rendez_vous_id: number;
	id_agent: number;
	id_employer: number;
	agenda_id: number;
	consultation_date_entre: Date;
	consultation_heure_entre: any;
	consultation_heure_sortie: any;
	consultation_observation: any;
	consultation_conseil: any;
	consultation_dagnostic_probable: any;
	consultation_diagnostic_finale: any;
	motifConsultation: MotifConsultation;
	consultation_autre_parametre: any;
	//motif_consultation : String;
	consultation_motif: String;
	soins_dentaire: any;
	consultation_signephysiques: any;
	consultation_signegeneraux: any;
	consultation_signefonctionnels: any;
	consultation_signe_clinique: String;
	consultation_reference: String;
	conjoints: Conjoint;
	employer: Employer;
	maladie: Maladie;
	examen: Examen;
	examens: Array<Examen> = new Array<Examen>();
	rendez_vous: RendezVous;
	listeRendez_vous: Array<RendezVous> = new Array<RendezVous>();
	repos: Repos;
	ordonnance: Ordonnance;
	listeSoins: Array<Soins> = new Array<Soins>();
	documents: Array<Document> = new Array<Document>();
	vaccins: Array<Vaccin> = new Array<Vaccin>();
	agenda: Agenda;
	actes: Array<Actes> = new Array<Actes>();
	ophtalmo: Ophtalmo = new Ophtalmo();

	//id_medicament:any;

	constructor($consultation_id: any, $consultation_signe: any,
		// $consultation_heure_entre:any,
		// $consultation_heure_sortie:any,
		//$consultation_dagnostic_probable:any,
		//$consultation_diagnostic_finale:any,
		$motifConsultation: MotifConsultation,
		$conjoints: Conjoint,
		$employer: Employer,
		$maladie: Maladie) {
		this.consultation_id = $consultation_id;
		this.consultation_signe = $consultation_signe;
		// this.consultation_heure_entre=$consultation_heure_entre;
		// this.consultation_heure_sortie= $consultation_heure_sortie;
		//this.consultation_dagnostic_probable=$consultation_dagnostic_probable;
		//this.consultation_diagnostic_finale=$consultation_diagnostic_finale;
		this.motifConsultation = $motifConsultation;
		this.conjoints = $conjoints;
		this.employer = $employer;
		this.maladie = $maladie;
		this.examen = new Examen(null, null);
		this.rendez_vous = new RendezVous();
		this.repos = new Repos();
		this.agenda = new Agenda(null, null, null);
	}

}
